<template>
  <div>
    <div class="load-div" v-if="loading">
      <b-spinner variant="primary"/>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-9">
          <h4 class="text-primary d-flex flex-column">
            <span class="mb-2">Nombre del flujo: <b>{{ data.aprobacion.nombre }}</b></span>
            <span class="mb-2">Doc. Referencia: <b>{{ getDocRef() }}</b></span>
            <span class="mb-2">Unidad: <b>{{ getUnitName() }}</b></span>
          </h4>
        </div>
        <div class="col-3">
          <div class="d-flex justify-content-end align-items-start mb-5">
            <vs-button
              @click="backToList"
              variant="primary"
              icon="arrow_back"
            >
              Volver
            </vs-button>
          </div>
        </div>
      </div>
      <div class="row height">
        <div class="col-12 mb-4 info">
          <ConsequencesInfo v-if="forms.consequences"/>
          <ObserversInfo v-if="forms.observers"/>
          <StepsInfo v-if="forms.steps"/>
        </div>
      </div>
      <div class="row">
        <div class="col-9">
          <FlowDetail
            @flowDetail="setFlowDetail"
            :tipoOficina="data.aprobacion.tipoOficina"
            v-show="forms.flowDetail"
          />
          <Observers @observers="addObservers" v-show="forms.observers"/>
          <b-card class="scroll" title="Consecuencias" v-show="forms.consequences">
            <Consequences
              @consequences="addConsequences"
              v-show="forms.consequences"
              :reference="data.aprobacion.tipoObjeto"
              :original="aprovalTemplate.gatillaciones"
            />
          </b-card>
          <Steps
            :errorOnSave="errorOnSave"
            :flowType="data.aprobacion.tipoEjecucion"
            :examplePdf="aprovalTemplate
            && aprovalTemplate.aprobacion ? aprovalTemplate.aprobacion.pdfEjemplo: null"
            @steps="data.pasos = $event"
            @set-office-type="setOfficeType"
            @filePreview="data.filePreview = $event"
            v-show="forms.steps"
            :reference="data.aprobacion.tipoObjeto"
          />
        </div>
        <div class="col-3">
          <TemplatePartsButtons
            :saveData="saveData"
            :data="data"
            :forms="forms"
            :setForm="setForm"
            :getBtnText="getBtnText"
            :loadingBtn="loadingBtn"
          />
        </div>
      </div>
      <b-modal
        title-class="font-weight-bold text-success"
        centered
        size="sm"
        no-close-on-backdrop
        :title="`Plantilla ${editMode ? 'editada' : 'guardada'}`"
        ref="templateModal"
        hide-header-close
      >
        <h5>La plantilla se ha {{ `${editMode ? 'editado' : 'guardado'}` }} correctamente</h5>
        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="success"
              class="float-right"
              @click="$router.push({
                name: 'approval-templates'
              })"
            >
              Ok
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ConsequencesInfo from '@/febos/chile/approvals/components/templates/ConsequencesInfo';
import ObserversInfo from '@/febos/chile/approvals/components/templates/ObserversInfo';
import StepsInfo from '@/febos/chile/approvals/components/templates/StepsInfo';
import FlowDetail from '@/febos/chile/approvals/components/templates/FlowDetail';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import Observers from '@/febos/chile/approvals/components/templates/Observers';
import Consequences from '@/febos/chile/approvals/components/templates/Consequences';
import Steps from '@/febos/chile/approvals/components/templates/Steps';
import TemplatePartsButtons
from '@/febos/chile/approvals/components/templates/TemplatePartsButtons';
import { DESATENDIDA } from '@/febos/chile/approvals/components/templates/AprovalMixin';
import StepTypes from "@/febos/chile/dnt/mixins/StepTypes";

export default {
  name: 'ManageTemplate',
  components: {
    FlowDetail,
    Observers,
    Consequences,
    Steps,
    TemplatePartsButtons,
    ConsequencesInfo,
    ObserversInfo,
    StepsInfo
  },
  data() {
    return {
      loading: true,
      loadingBtn: false,
      errorOnSave: '',
      rolTypes: RolTypes,
      forms: {
        flowDetail: true,
        observers: false,
        consequences: false,
        steps: false
      },
      data: {
        aprobacion: {
          tipoOficina: 'I',
          gatilladores: [],
          observadores: []
        },
        observadores: [],
        gatilladores: [],
        pasos: [],
        filePreview: null
      }
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'referenceApprovals',
      'aprovalTemplate'
    ]),
    ...mapGetters('Empresas', [
      'groupsCompany',
      'empresa'
    ]),
    editMode() {
      return this.$route.params.view === 'edit';
    },
    duplicateMode() {
      return this.$route.params.view === 'duplicate';
    },
    getBtnText() {
      let text = '';
      if (this.loadingBtn && !this.editMode) text = 'Guardando...';
      if (!this.loadingBtn && !this.editMode) text = 'Guardar';
      if (this.loadingBtn && this.editMode) text = 'Editando...';
      if (!this.loadingBtn && this.editMode) text = 'Editar';
      return text;
    },
  },
  methods: {
    ...mapActions('Approvals', [
      'addApprovalTemplate',
      'editApprovalTemplate',
      'fetchApprovalTemplate'
    ]),
    ...mapActions('Empresas', ['getGroupsCompany']),
    getDocRef() {
      let docRef = '';
      if (this.referenceApprovals.length) {
        docRef = this.referenceApprovals.find(
          (gc) => gc.valor === this.data.aprobacion.tipoObjeto
        )?.descripcion;
      }
      return docRef;
    },
    getUnitName() {
      let unitName = '';
      if (this.groupsCompany.length) {
        unitName = this.groupsCompany.find(
          (gc) => gc.id === this.data.aprobacion.unidad
        )?.nombre;
      }
      return unitName;
    },
    backToList() {
      this.$router.push({ name: 'approval-templates' });
    },
    addObservers(observers) {
      this.data.observadores = observers;
      this.data.aprobacion.observadores = observers;
    },
    setOfficeType(value) {
      this.data.aprobacion.tipoOficina = value;
    },
    setFlowDetail(event) {
      const currentTipoOficina = this.data.aprobacion.tipoOficina;

      this.data.aprobacion = { ...this.data.aprobacion, ...event };

      // Si el evento trae tipoOficina "I" pero ya teníamos otro valor, mantener el actual
      if (event.tipoOficina === 'I' && currentTipoOficina && currentTipoOficina !== 'I') {
        this.data.aprobacion.tipoOficina = currentTipoOficina;
      }

    },
    addConsequences(consequences) {
      this.data.gatilladores = consequences;
      this.data.aprobacion.gatilladores = consequences;
    },
    setForm(form, value) {
      Object.entries(this.forms).forEach((entry) => {
        this.forms[entry[0]] = false;
      });
      this.forms[form] = value;
    },
    checkRequiredData() {
      let hasError = false;
      if (
        this.data.aprobacion.nombre.trim().length === 0
        || this.data.aprobacion.descripcion.trim().length === 0
      ) {
        hasError = true;
        this.$vs.notify({
          title: 'Oops!',
          text: 'Debe haber un nombre, descripción y al menos un paso para poder guardar.',
          color: 'danger',
          time: 10000,
          position: 'top-center'
        });
      }

      if (this.data.pasos.length === 0) {
        hasError = true;
        this.$vs.notify({
          title: 'Oops!',
          text: 'Debe haber al menos un paso para poder guardar.',
          color: 'danger',
          time: 10000,
          position: 'top-center'
        });
      }
      if (this.data.pasos.slice(-1)[0].aprobacionesTipoRolId === this.rolTypes.REVIEWER) {
        hasError = true;
        this.$vs.notify({
          title: 'Oops!',
          text: 'El último paso no debe ser de tipo "Revisor"',
          color: 'danger',
          time: 10000,
          position: 'top-center'
        });
      }
      const hasSigner = this.data.pasos.some(
        (step) => step.aprobacionesTipoRolId === RolTypes.SIGNER && step.aprobacionesTipoPasoId !== StepTypes.OFFICE
      );
      if (this.data.pasos.length && this.data.pasos[0].aprobacionesTipoPasoId === StepTypes.OFFICE) {
        this.errorOnSave = 'Oops! No puedes agregar una oficina como primer paso';
        hasError = true;
      }
      const hasOffice = this.data.pasos.some(
        (step) => step.aprobacionesTipoRolId === RolTypes.SIGNER && step.aprobacionesTipoPasoId === StepTypes.OFFICE
      );
      if (hasOffice && !hasSigner) {
        this.errorOnSave = 'No se puede realizar las acciones de la oficina sin un paso de rol firmante';
        hasError = true;
      }
      const isDesatendida = this.data.aprobacion.desatendida === DESATENDIDA;
      if (
        isDesatendida
      ) {
        const notHasPosition = this.data.pasos.some(
          (p) => p.aprobacionesTipoRolId === this.rolTypes.SIGNER
            && (!p.pagina || !p.x || !p.y)
        );
        if (notHasPosition) {
          hasError = true;
          this.$vs.notify({
            title: 'Oops!',
            text: 'La aprobación no puede ser desatendida si a no se les asigna la posición de la estampa a todos los firmantes',
            color: 'danger',
            time: 10000,
            position: 'top-center'
          });
        }
      }
      if (hasError) {
        throw new Error('Faltan datos para poder guardar');
      }
    },
    async saveData() {
      this.checkRequiredData();
      this.loadingBtn = true;
      if (this.data.filePreview) {
        this.data.aprobacion.pdfEjemplo = this.data.filePreview.path;
      }
      const data = JSON.parse(JSON.stringify(this.data));
      data.pasos = data.pasos.map((paso) => {
        // check if configuration is object
        if (paso.configuration && typeof paso.configuration === 'object' && Object.keys(paso.configuration).length > 0) {
          // eslint-disable-next-line no-param-reassign
          paso.configuration = JSON.stringify(paso.configuration);
        }
        // eslint-disable-next-line no-param-reassign
        paso.distributed = paso.distributed ? 1 : 0;
        return paso;
      });
      try {
        if (this.editMode) {
          data.aprobacion.id = this.$route.params.id;
          await this.editApprovalTemplate(data);
        } else {
          await this.addApprovalTemplate(data);
        }
      } finally {
        this.loadingBtn = false;
      }
      this.$refs.templateModal.show();
    }
  },
  async created() {
    if (this.editMode || this.duplicateMode) {
      await this.fetchApprovalTemplate({
        id: this.$route.params.id,
        estado: true
      });
      this.addConsequences(this.aprovalTemplate.gatillaciones);
    } else {
      this.$store.commit('Approvals/SET_APPROVAL_TEMPLATE', {});
    }
    await this.getGroupsCompany({
      empresaId: this.empresa.id
    });
    this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
.scroll {
  max-height: 420px;
  @media screen and (min-height: 769px) {
    max-height: 550px;
  }
  overflow: auto;
}
.load-div {
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.height {
  min-height: 55px;
}
</style>
